export const scrollToSection = (id: any) => {
  document?.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};
